import * as urls from 'routes/config';
import { Navigate } from 'react-router-dom';
import { useBusiness } from 'providers/context/BusinessProvider';
import { CacheKeys } from 'utils/cacheKeys';
import { useGetAgents } from 'apis/business/agent/hook';
import Spinner from 'components/Common/Spinner';
// import { useGetBusinessProfile } from 'apis/business/hook';
import { useAgent } from 'providers/context/AgentProvider';
import { useGetCurrentUser } from 'apis/user/hook';

export default function Home() {
  const { selectedWorkspace } = useBusiness();
  const { selectedAgentId } = useAgent();
  const { data: currentUser, isLoading: isCurrentUserLoading } = useGetCurrentUser();

  let agentIds;
  if (localStorage.getItem(CacheKeys.agentIds)) {
    agentIds = JSON.parse(localStorage.getItem(CacheKeys.agentIds) ?? '');
  }
  const { data: agents, isLoading } = useGetAgents(selectedWorkspace!);
  // const { data: business, isLoading: isBusinessLoading } = useGetBusinessProfile({
  //   enabled: Boolean((!currentUser?.agency_user && !isCurrentUserLoading) || selectedBusiness)
  // });

  const selectFirstAgentDefault = selectedAgentId
    ? selectedAgentId
    : agentIds?.length > 0
      ? agentIds[0]
      : agents?.data?.[0]?.id;

  if (isLoading || isCurrentUserLoading) {
    return <Spinner />;
  }

  if (currentUser?.agency_user && !selectedWorkspace) {
    return <Navigate to={urls.agency.base} replace />;
  }

  if (selectFirstAgentDefault !== undefined) {
    return <Navigate to={urls.agentBase(selectedWorkspace!, selectFirstAgentDefault)} replace />;
  }
  if (selectFirstAgentDefault === undefined) {
    return <Navigate to={`${urls.base(selectedWorkspace!)}/${urls.onBoarding.selectAgent}`} />;
  }
  return <Navigate to={`${urls.base(selectedWorkspace!)}/${urls.onBoarding.create}`} replace />;
}
